module.exports = __webpack_public_path__ + "img/AddAPhotoOutlined.9d325949.svg";